import * as angular from "angular";
import {IController, IScope} from "angular";
import {SitesRequestsService} from "../../../sites/services/sites-requests.service";
import {SplitService} from "../../services/split-service.service";


export class UserFormCtrl implements IController {

  user: any;
  allowUserDuplication: any
  loading: boolean;
  onLoadingChange: Function;
  onChange: Function;

  public email: string;
  public country: string;
  private initEmail: string;

  constructor(private $scope: IScope, private $element, private sitesRequestsService: SitesRequestsService,
              private splitService: SplitService, private IamService, private $log) {
  }

  $onInit() {
    this.country = this.splitService.getCountryCode();
    this.initEmail = angular.copy(this.user.email);
    this.email = this.user.email;
  }

  emailChanged(form) {
    //Same email, skip the validation
    if (this.email === this.initEmail) {

      form.email.$setValidity('exists', true);

    } else if (!this.allowUserDuplication) {

      this.onLoadingChange({loading: true});
      this.IamService.validateUserEmail(this.email)
        .then((valid) => {

          if (valid) {
            this.user.email = this.email;
            this.onChange({user: this.user});
          }

          form.email.$setValidity('exists', valid);
        })
        .catch(() => {
          this.$log.debug('Fail to validate user email');
        })
        .finally(() => {
          this.onLoadingChange({loading: false});
        })
    } else {
      this.user.email = this.email;
      this.onChange({user: this.user});
    }
  }

  onPhoneChange(phone) {
    this.user.mobilePhone = phone;
  }

  secondaryPhoneChanged(phone) {
    this.user.additionalPhone = phone;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('userForm', {
    require: {
      form: '^form'
    },
    bindings: {
      user: '<',
      allowUserDuplication: '<?',
      loading: '<?',
      onLoadingChange: '&',
      onChange: '&'
    },
    template: require('./user-form.html').default,
    controller: UserFormCtrl
  });

